import get from 'lodash/get';
import { createSelector } from 'reselect';
import { sharingSelector } from '../../sharing/selectors';
import { SCOPE } from './types';

const selector = state => get(state, SCOPE);
export default selector;

export const alertDiagnosticsUpdateSelector = createSelector(
  sharingSelector,
  sharingState => sharingState.state,
);
